export class PasswordResetRequest {
  public email!: string;

  constructor(values?: PasswordResetRequest) {
    Object.assign(this, values);
  }
}
